export const OPEN_WORKFLOW_CREATION_WIZARD = 'OPEN_WORKFLOW_CREATION_WIZARD';
export const CLOSE_WORKFLOW_CREATION_WIZARD = 'CLOSE_WORKFLOW_CREATION_WIZARD';

/**
 * Note: integrationType is one of the ids keys of COMBINED object
 * exported by IntegrationsManager/data.
 */
export function openWorkflowCreationWizard(integrationType) {
  return {
    type: OPEN_WORKFLOW_CREATION_WIZARD,
    payload: {
      integrationType,
    },
  };
}

export function closeWorkflowCreationWizard() {
  return {
    type: CLOSE_WORKFLOW_CREATION_WIZARD,
  };
}
